const state = {
    route: {
        path: '',
        query: null
    }
};

//操作管理
const mutations = {
    SET_PAGE_QUERY(state, data = null) {
        state.route.path = data?.path
        state.route.query = data?.query
    }
}

// 异步操作
const actions = {
    setCloudTaskPageQuery({ commit }, data = null) {
        commit('SET_PAGE_QUERY', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
